import { isMarketingHost } from '../../utils/siteHost';
import { PublicRoute } from '../auth/PublicRoute';

import { RedirectToAppHost } from './RedirectToAppHost';

/** Login/register only run on the app host. */
export function AppPublicRoute({
  children,
}: {
  children: React.ReactNode;
}) {
  if (isMarketingHost()) {
    return <RedirectToAppHost />;
  }
  return <PublicRoute>{children}</PublicRoute>;
}
